import { environment } from '@/environments/environment'

export default [
  { name: 'getTeamsUsers', url: `${environment.apiPlatform}/v1/teams/users`, method: 'get' },
  { name: 'getTeamsUsersId', url: `${environment.apiPlatform}/v1/teams/users/{user_id}`, method: 'get' },
  { name: 'postTeamsUsers', url: `${environment.apiPlatform}/v1/teams/users`, method: 'post'},
  { name: 'putTeamsUsers', url: `${environment.apiPlatform}/v1/teams/users/{user_id}`, method: 'put'},
  { name: 'deleteTeamsUsersId', url: `${environment.apiPlatform}/v1/teams/users/{user_id}`, method: 'DELETE' }
]
